import {registerTemplateGraphNode} from "#template/template-node/register"
import {z} from "zod/v4-mini"
import {VariableNode} from "#template/nodes/variable/variable-node"
import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

export type S1VariableParameters = {
    default: [number, number]
}

const s1VariableDefinition: TemplateNodeDefinition<S1VariableParameters> = {
    nodeClass: "S1Variable",
    validation: {
        parameters: z.object({
            default: z.tuple([z.number(), z.number()]),
        }),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class S1Variable extends VariableNode<S1VariableParameters> {
    public override get definition() {
        return s1VariableDefinition
    }
}
